import { CommApiInstance } from "Utils/CommApiInstance";

const GameSvcCdRelLstApi = async (
    gameSvcCd:string,
    gamePltf:string|null,
) => {
    return await CommApiInstance.post(`comm/game_svc_cd_lst/rel`,{
        apiBody:{
            gameSvcCd:gameSvcCd,
            gamePltf:gamePltf,
        },
    })
    .then((Resp) => Resp.data);
}
export default GameSvcCdRelLstApi;